module.exports = __webpack_public_path__ + "static/media/kredyt_34.f6069449.png";